import { render, staticRenderFns } from "./newsPage08.vue?vue&type=template&id=0f097470&scoped=true&"
import script from "./newsPage08.vue?vue&type=script&lang=js&"
export * from "./newsPage08.vue?vue&type=script&lang=js&"
import style0 from "./newsPage08.vue?vue&type=style&index=0&id=0f097470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f097470",
  null
  
)

export default component.exports